import { Flex, Grid, GridItem, HStack, Icon, Link, Text, VStack } from '@chakra-ui/react';
import { Navigate, Outlet, Link as RouterLink, useLocation } from 'react-router-dom';

import Logo from '@/client/components/media/images/Logo';
import { QuestionCircle } from '../icons/ContinuIcons';
import { useAuthStore } from '@/client/services/state/authStore';
import { useConfigStore } from '@/client/services/state/configStore';
import { useGetBackgroundImageUrl } from '@/client/services/hooks/preauth/useGetBackgroundImageUrl';
import { useTranslation } from 'react-i18next';

export default function LoggedOutLayout() {
  const location = useLocation();
  const { pathname } = location;
  const { authConfig } = useAuthStore();
  const { config } = useConfigStore();
  const { t } = useTranslation();
  const { getBackgroundImageUrl } = useGetBackgroundImageUrl();

  if (authConfig.authtoken) {
    return <Navigate to="/explore" replace />;
  }

  return (
    <Grid templateColumns="repeat(16, 1fr)" gap={0} height="100vh" minHeight="100vh">
      <GridItem
        colSpan={{ base: 16, lg: 6 }}
        height="full"
        minHeight="full"
        paddingTop={16}
        paddingX={{ base: 8, md: 12 }}
      >
        <Flex
          maxWidth="400px"
          margin="0 auto"
          minHeight="full"
          direction="column"
          justifyContent="flex-start"
          position="relative"
        >
          <Flex justifyContent="flex-start" alignItems="center" direction="row">
            <Logo variant="login" />
          </Flex>

          <Flex flex={1} marginTop={28} direction="column" paddingBottom={4}>
            <Outlet />

            <VStack spacing={2} marginTop={2}>
              <HStack margin="0 auto" spacing={1}>
                <Icon boxSize={4} as={QuestionCircle} color="neutral.800" />

                <Text fontSize="14px" fontWeight={500} color="neutral.800">
                  {t('login.needHelp')}
                  <Link
                    variant="neutral"
                    href={`mailto:${config.supportEmailAddress}`}
                    marginLeft={1}
                  >
                    {t('preauth.signin.contactSupport')}
                  </Link>
                </Text>
              </HStack>

              {!pathname.startsWith('/login') && (
                <Text fontSize="14px" fontWeight={500} color="neutral.800">
                  <Link as={RouterLink} variant="neutral" to="/login">
                    {t('preauth.signin.button')}
                  </Link>
                </Text>
              )}
            </VStack>

            <Text
              fontSize="12px"
              fontWeight={500}
              color="neutral.800"
              textAlign="center"
              position="absolute"
              bottom={4}
              left={0}
              right={0}
            >
              &copy; {t('login.copyright')}
            </Text>
          </Flex>
        </Flex>
      </GridItem>

      <GridItem
        colSpan={{ base: 0, lg: 10 }}
        display={{ base: 'none', lg: 'block' }}
        backgroundImage={`url(${getBackgroundImageUrl()})`}
        backgroundPosition="center center"
        backgroundSize="cover"
        backgroundRepeat="no-repeat"
      />
    </Grid>
  );
}
